export default __webpack_public_path__ + "static/1-2b41405fdacf8773735020d82d4bcca1.png";